import React from "react";
import imgCopy from '../../../assets/siteManagement/images/copy.svg'
import imgSave from '../../../assets/siteManagement/images/save.svg'
import ButtonFuncBottom from "./button-func";
import CopyIcon from "../../site_management/icons/CopyIcon";
import SaveIcon from "../../site_management/icons/SaveIcon";
import { useTranslation } from 'react-i18next'

function BottomAddEditBox(props) {
    const { t } = useTranslation("settings");

    function onClickSaveAndDup() {
        try {
            props.onClickSaveAndDup();
        } catch { }
    }
    function onClickSave() {
        try {
            props.onClickSave();
        } catch { }
    }

    return (
        <div className="h-full py-1 flex">
            <div className="mr-1">
                <ButtonFuncBottom
                    text={`${t('site_management.save_and_duplicate')}`}
                    icon={<CopyIcon className="w-4 h-4 text-vekin-primary-dark" />}
                    onClick={(e) => { onClickSaveAndDup() }}
                />
            </div>

            <div className="w-px h-full bg-quartenary">
            </div>

            <div className="ml-1">
                <ButtonFuncBottom
                    text={`${t('site_management.save')}`}
                    icon={<SaveIcon className="w-4 h-4 text-vekin-primary-dark" />}
                    onClick={(e) => { onClickSave() }}
                />
            </div>
        </div>
    )
}

export default BottomAddEditBox;